import React from "react";
import { useTranslation } from "react-i18next";
import { STREAMS } from "../../utils/folders";

// A subject folder's stream: null (both streams), "kk" (КАЗ) or "ru" (РУС).
export const STREAM_CHOICES = [null, ...STREAMS];

// The streams a catalog subject already has among an exam's subject folders (other than the folder `except`).
export const takenStreams = (subjects, subjectUuid, except) =>
  new Set(
    (subjects || [])
      .filter((s) => subjectUuid && s.subject?.uuid === subjectUuid && s.uuid !== except)
      .map((s) => s.stream ?? null)
  );

// The choice of a subject's stream, each with what it means; a stream the subject already has in the exam is
// disabled (the backend refuses the same subject and stream twice). `value` is null, "kk" or "ru".
export default function StreamChoice({ name, value, onChange, taken, error = "", errorId, disabled = false }) {
  const [t] = useTranslation();
  return (
    <fieldset disabled={disabled} aria-describedby={error ? errorId : undefined}>
      <legend className="mb-1.5 block text-sm font-medium text-slate-700">{t("folders.stream.label")}</legend>
      <div className="space-y-2">
        {STREAM_CHOICES.map((stream) => {
          const key = stream || "both";
          const isTaken = !!taken?.has(stream);
          const checked = value === stream;
          // A taken stream, or the whole choice while it is disabled, reads as unavailable.
          const off = isTaken || disabled;
          return (
            <label
              key={key}
              className={`flex items-start gap-3 rounded-lg px-3 py-2.5 text-left ring-1 ring-inset transition duration-200 ${
                checked ? "bg-blue-50 ring-blue-600" : "bg-white ring-slate-200"
              } ${off ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:bg-slate-50"}`}
            >
              <input
                type="radio"
                name={name}
                checked={checked}
                disabled={isTaken}
                onChange={() => onChange(stream)}
                className="mt-0.5 h-4 w-4 shrink-0 border-slate-300 text-blue-600 focus:ring-blue-600"
              />
              <span className="min-w-0">
                <span className="block text-sm font-medium text-slate-900">
                  {t(`folders.stream.${key}`)}
                  {isTaken && <span className="ml-1.5 text-xs font-normal text-slate-500">· {t("folders.stream.taken")}</span>}
                </span>
                <span className="block text-xs text-slate-500">{t(stream ? "folders.stream.one_hint" : "folders.stream.both_hint")}</span>
              </span>
            </label>
          );
        })}
      </div>
      {error && (
        <p id={errorId} role="alert" className="mt-1.5 text-sm text-red-600">
          {error}
        </p>
      )}
    </fieldset>
  );
}
